import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../../actions/lister-actions';
import { useIsSmallAndAbove } from '../../../hooks/mediaQueries';
import TRANSLATIONS from './translations@default.json';

export const SmallReviewsLayout = ({
	Rating,
	RatingValue,
	ReviewCount,
	isRecommendedProduct,
	classes,
}) => {
	const { isDealsPage } = useSelector((state) => state);

	return (
		<div
			className={classnames('product-card__rating flex text-sm', classes, {
				'items-center': RatingValue !== '0.0',
				'flex-col': RatingValue === '0.0',
			})}
			itemProp="aggregateRating"
			itemScope
			itemType="http://schema.org/AggregateRating"
			data-testid="small-reviews-layout">
			<meta itemProp="ratingValue" content={RatingValue} />
			<meta itemProp="ratingCount" content={ReviewCount} />

			<span className={`product-card__rating-stars mr-1 rating-${Rating}`} />

			{!isRecommendedProduct && (
				<span
					className={classnames('text-body-xs', {
						'text-tertiary': !isDealsPage,
						'font-bold text-secondary': isDealsPage,
					})}>
					(
					<span className="whitespace-no-wrap">
						{ReviewCount}
					</span>
					)
				</span>
			)}

			{isRecommendedProduct && RatingValue > 0 && (
				<span className="text-caption font-regular">{RatingValue} / 5</span>
			)}

			{isRecommendedProduct && RatingValue === '0.0' && (
				<div className="text-caption font-regular">
					{TRANSLATIONS.notYetReviewed}
				</div>
			)}
		</div>
	);
};

const LargeReviewsLayout = ({
	Rating,
	RatingValue,
	ReviewCount,
	FullProductUrl,
	Code,
	classes,
}) => {
	const dispatch = useDispatch();

	return (
		<div
			className={`${classes} product-card__rating text-sm`}
			itemProp="aggregateRating"
			itemScope
			itemType="http://schema.org/AggregateRating"
			data-testid="large-reviews-layout">
			<meta itemProp="ratingValue" content={RatingValue} />
			<meta itemProp="ratingCount" content={ReviewCount} />

			<a
				href={`${FullProductUrl}#reviewsSection`}
				aria-label={`${RatingValue} out of 5 stars, ${ReviewCount} reviews`}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(`${FullProductUrl}#reviewsSection`);

					dispatch(listerClickThrough(Code));
				}}
				className="inline-flex flex-wrap items-center text-cta-action font-regular"
				itemProp="url"
				data-testid="product-card-link">
				<span
					className={`rating-${Rating} product-card__rating-stars mt-2 mr-1`}
				/>

				<span className="mt-2 text-link text-body-xs">
					<span className="product-card__rating-value mr-1">
						{`${RatingValue} / 5`}
					</span>

					<span className="product-card__rating-count">
						(
						<span className="whitespace-no-wrap">
							{ReviewCount} {TRANSLATIONS.amountOfReviews}
						</span>
						)
					</span>
				</span>
			</a>
		</div>
	);
};

const ReviewRating = (props) => {
	const { Rating, RatingValue, ReviewCount, isRecommendedProduct } = props;

	const isSmallAndAbove = useIsSmallAndAbove();

	if (isRecommendedProduct) {
		return <SmallReviewsLayout {...{ ...props }} />;
	}

	if (Rating && ReviewCount && RatingValue && RatingValue > 0) {
		if (isSmallAndAbove) {
			return <LargeReviewsLayout {...props} />;
		}

		return <SmallReviewsLayout {...props} />;
	}

	return null;
};

export default ReviewRating;
